import React from 'react';
import { Link } from 'react-router-dom';
import { JOIN_IMAGE } from '../../data/smaken';
import { Reveal } from '../Reveal';
import { ArrowMark } from '../Marks';
export function JoinBanner() {
  return <section aria-labelledby="join-rubrik" className="bg-blaa text-papper" data-id="element-468" data-mp="20npylt4x21ln">
      <div className="mx-auto grid max-w-page items-center gap-10 px-5 py-16 md:px-8 md:py-20 lg:grid-cols-[minmax(0,1fr),minmax(0,1fr)] lg:gap-16" data-id="element-469" data-mp="1voms049afnbk">
        <Reveal data-id="element-470" data-mp="29mjtnf2lmjx3">
          <h2 id="join-rubrik" className="display-xl text-4xl uppercase leading-[0.92] sm:text-6xl" data-id="element-471" data-mp="29m1lpl6kqh9c">
            Är du en av oss?
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-papper/80" data-id="element-472" data-mp="2je7egx4nh2pl">
            Driver du ett bageri, en restaurang, gårdsbutik, producentverksamhet eller något annat riktigt
            gott?
          </p>
          <Link to="/bli-en-del" className="group mt-8 inline-flex items-center gap-3 bg-papper px-8 py-4 text-[12px] font-bold uppercase tracking-wide2 text-black transition-colors duration-150 ease-out hover:bg-smor" data-id="element-473" data-mp="2sffbzczcdzim">
            Bli en del av Småken
            <ArrowMark className="h-3.5 w-8 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-474" data-mp="299bn7ftqsk1b" />
          </Link>
        </Reveal>

        <Reveal delay={0.08} data-id="element-475" data-mp="2e9px73ewm41z">
          <img src={JOIN_IMAGE} alt="Två bagare i dörröppningen till sitt bageri på morgonen" loading="lazy" className="aspect-[16/10] w-full object-cover" data-id="element-476" data-mp="2j6zjia6zxzll" />
        </Reveal>
      </div>
    </section>;
}